import { lazy } from 'react';
// ページID → コンポーネントの対応表
// 新しい記事・ツールページを追加するときは、ここに1行追加し、
// src/data/pageMeta.json にタイトル・説明文を追加する。
// 記事・ツールページは lazy()（開いたときに初めてダウンロード）で登録する。

import HomePage from './pages/HomePage';
import ToolsPage from './pages/ToolsPage';
import ArticlesPage from './pages/ArticlesPage';
import ProfilePage from './pages/ProfilePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

const DripCalculatorPage = lazy(() => import('./pages/tools/DripCalculatorPage'));
const DesignRCalculatorPage = lazy(() => import('./pages/tools/DesignRCalculatorPage'));
const BradenCalculatorPage = lazy(() => import('./pages/tools/BradenCalculatorPage'));
const ConsciousnessToolPage = lazy(() => import('./pages/tools/ConsciousnessToolPage'));
const UrineOutputToolPage = lazy(() => import('./pages/tools/UrineOutputToolPage'));
const BarthelIndexPage = lazy(() => import('./pages/tools/BarthelIndexPage'));
const NewsScoreToolPage = lazy(() => import('./pages/tools/NewsScoreToolPage'));
const Fio2ToolPage = lazy(() => import('./pages/tools/Fio2ToolPage'));
const DesignRArticlePage = lazy(() => import('./pages/articles/DesignRArticlePage'));
const BradenScaleArticlePage = lazy(() => import('./pages/articles/BradenScaleArticlePage'));
const ConsciousnessLevelArticlePage = lazy(() => import('./pages/articles/ConsciousnessLevelArticlePage'));
const NewsScoreArticlePage = lazy(() => import('./pages/articles/NewsScoreArticlePage'));
const PainScaleArticlePage = lazy(() => import('./pages/articles/PainScaleArticlePage'));
const EnemaArticlePage = lazy(() => import('./pages/articles/EnemaArticlePage'));
const BloodCollectionArticlePage = lazy(() => import('./pages/articles/BloodCollectionArticlePage'));
const Fio2ConversionArticlePage = lazy(() => import('./pages/articles/Fio2ConversionArticlePage'));
const IngrownToenailArticlePage = lazy(() => import('./pages/articles/IngrownToenailArticlePage'));
const HdsrArticlePage = lazy(() => import('./pages/articles/HdsrArticlePage'));
const EyeDropsArticlePage = lazy(() => import('./pages/articles/EyeDropsArticlePage'));
const SuctioningArticlePage = lazy(() => import('./pages/articles/SuctioningArticlePage'));
const BalloonCatheterArticlePage = lazy(() => import('./pages/articles/BalloonCatheterArticlePage'));
const NasogastricFeedingArticlePage = lazy(() => import('./pages/articles/NasogastricFeedingArticlePage'));
const DeliriumAssessmentArticlePage = lazy(() => import('./pages/articles/DeliriumAssessmentArticlePage'));
const DisinfectantDilutionArticlePage = lazy(() => import('./pages/articles/DisinfectantDilutionArticlePage'));
const LungSoundsArticlePage = lazy(() => import('./pages/articles/LungSoundsArticlePage'));
const PeripheralCirculationArticlePage = lazy(() => import('./pages/articles/PeripheralCirculationArticlePage'));
const EdemaArticlePage = lazy(() => import('./pages/articles/EdemaArticlePage'));
const PressureUlcerCareArticlePage = lazy(() => import('./pages/articles/PressureUlcerCareArticlePage'));
const HandHygieneArticlePage = lazy(() => import('./pages/articles/HandHygieneArticlePage'));
const ConstipationAssessmentArticlePage = lazy(() => import('./pages/articles/ConstipationAssessmentArticlePage'));
const SbarReportingArticlePage = lazy(() => import('./pages/articles/SbarReportingArticlePage'));
const WoundObservationArticlePage = lazy(() => import('./pages/articles/WoundObservationArticlePage'));
const InsomniaResponseArticlePage = lazy(() => import('./pages/articles/InsomniaResponseArticlePage'));
const SoapArticlePage = lazy(() => import('./pages/articles/SoapArticlePage'));
const AnemiaArticlePage = lazy(() => import('./pages/articles/AnemiaArticlePage'));
const DehydrationArticlePage = lazy(() => import('./pages/articles/DehydrationArticlePage'));
const ToromiArticlePage = lazy(() => import('./pages/articles/ToromiArticlePage'));
const HisshinArticlePage = lazy(() => import('./pages/articles/HisshinArticlePage'));
const BloodPressureMeasurementArticlePage = lazy(() => import('./pages/articles/BloodPressureMeasurementArticlePage'));
const PulseMeasurementArticlePage = lazy(() => import('./pages/articles/PulseMeasurementArticlePage'));
const TemperatureMeasurementArticlePage = lazy(() => import('./pages/articles/TemperatureMeasurementArticlePage'));
const Spo2AssessmentArticlePage = lazy(() => import('./pages/articles/Spo2AssessmentArticlePage'));
const PulseAssessmentArticlePage = lazy(() => import('./pages/articles/PulseAssessmentArticlePage'));
const BloodPressureResponseArticlePage = lazy(() => import('./pages/articles/BloodPressureResponseArticlePage'));
const FeverResponseArticlePage = lazy(() => import('./pages/articles/FeverResponseArticlePage'));
const MnaSfArticlePage = lazy(() => import('./pages/articles/MnaSfArticlePage'));
const TwelveLeadEcgArticlePage = lazy(() => import('./pages/articles/TwelveLeadEcgArticlePage'));
const CamScreeningPage = lazy(() => import('./pages/tools/CamScreeningPage'));
const NuDescScreeningPage = lazy(() => import('./pages/tools/NuDescScreeningPage'));
const DisinfectantDilutionToolPage = lazy(() => import('./pages/tools/DisinfectantDilutionToolPage'));
const MnaSfCalculatorPage = lazy(() => import('./pages/tools/MnaSfCalculatorPage'));
const HdsrToolPage = lazy(() => import('./pages/tools/HdsrToolPage'));
const HdsrV2ToolPage = lazy(() => import('./pages/tools/HdsrV2ToolPage'));
const ManualEvacuationArticlePage = lazy(() => import('./pages/articles/ManualEvacuationArticlePage'));
const MasshoJomyakuroArticlePage = lazy(() => import('./pages/articles/MasshoJomyakuroArticlePage'));
const DoUnyouArticlePage = lazy(() => import('./pages/articles/DoUnyouArticlePage'));
const MiBasicsArticlePage = lazy(() => import('./pages/articles/MiBasicsArticlePage'));
const AssertionBasicsArticlePage = lazy(() => import('./pages/articles/AssertionBasicsArticlePage'));
const StaffCommunicationBasicsArticlePage = lazy(() => import('./pages/articles/StaffCommunicationBasicsArticlePage'));
const CbtPatientArticlePage = lazy(() => import('./pages/articles/CbtPatientArticlePage'));
const BehavioralEconomicsPatientArticlePage = lazy(() => import('./pages/articles/BehavioralEconomicsPatientArticlePage'));
const CriticalThinkingBasicsArticlePage = lazy(() => import('./pages/articles/CriticalThinkingBasicsArticlePage'));

export const PAGE_COMPONENTS = {
  home: HomePage,
  tools: ToolsPage,
  tool_drip: DripCalculatorPage,
  tool_design_r: DesignRCalculatorPage,
  tool_braden: BradenCalculatorPage,
  tool_consciousness: ConsciousnessToolPage,
  tool_urine_output: UrineOutputToolPage,
  tool_barthel: BarthelIndexPage,
  tool_news: NewsScoreToolPage,
  tool_fio2: Fio2ToolPage,
  articles: ArticlesPage,
  article_design_r: DesignRArticlePage,
  article_braden_scale: BradenScaleArticlePage,
  article_consciousness_level: ConsciousnessLevelArticlePage,
  article_news_score: NewsScoreArticlePage,
  article_pain_scale: PainScaleArticlePage,
  article_enema: EnemaArticlePage,
  article_blood_collection: BloodCollectionArticlePage,
  article_fio2_conversion: Fio2ConversionArticlePage,
  article_ingrown_toenail: IngrownToenailArticlePage,
  article_hdsr: HdsrArticlePage,
  article_eye_drops: EyeDropsArticlePage,
  article_suctioning: SuctioningArticlePage,
  article_balloon_catheter: BalloonCatheterArticlePage,
  article_nasogastric_feeding: NasogastricFeedingArticlePage,
  article_delirium_assessment: DeliriumAssessmentArticlePage,
  article_disinfectant_dilution: DisinfectantDilutionArticlePage,
  article_lung_sounds: LungSoundsArticlePage,
  article_peripheral_circulation: PeripheralCirculationArticlePage,
  article_edema: EdemaArticlePage,
  article_pressure_ulcer_care: PressureUlcerCareArticlePage,
  article_hand_hygiene: HandHygieneArticlePage,
  article_constipation_assessment: ConstipationAssessmentArticlePage,
  article_sbar_reporting: SbarReportingArticlePage,
  article_wound_observation: WoundObservationArticlePage,
  article_insomnia_response: InsomniaResponseArticlePage,
  article_soap: SoapArticlePage,
  article_anemia: AnemiaArticlePage,
  article_dehydration: DehydrationArticlePage,
  article_toromi: ToromiArticlePage,
  article_hisshin: HisshinArticlePage,
  article_blood_pressure_measurement: BloodPressureMeasurementArticlePage,
  article_pulse_measurement: PulseMeasurementArticlePage,
  article_temperature_measurement: TemperatureMeasurementArticlePage,
  article_spo2_assessment: Spo2AssessmentArticlePage,
  article_pulse_assessment: PulseAssessmentArticlePage,
  article_blood_pressure_response: BloodPressureResponseArticlePage,
  article_fever_response: FeverResponseArticlePage,
  article_mna_sf: MnaSfArticlePage,
  article_12_lead_ecg: TwelveLeadEcgArticlePage,
  tool_cam: CamScreeningPage,
  tool_nudesc: NuDescScreeningPage,
  tool_disinfectant_dilution: DisinfectantDilutionToolPage,
  tool_mna_sf: MnaSfCalculatorPage,
  tool_hdsr: HdsrToolPage,
  tool_hdsr_v2: HdsrV2ToolPage,
  article_manual_evacuation: ManualEvacuationArticlePage,
  article_massho_jomyakuro: MasshoJomyakuroArticlePage,
  article_dounyou: DoUnyouArticlePage,
  article_mi_basics: MiBasicsArticlePage,
  article_assertion_basics: AssertionBasicsArticlePage,
  article_staff_communication_basics: StaffCommunicationBasicsArticlePage,
  article_cbt_patient: CbtPatientArticlePage,
  article_behavioral_economics_patient: BehavioralEconomicsPatientArticlePage,
  article_critical_thinking_basics: CriticalThinkingBasicsArticlePage,
  profile: ProfilePage,
  privacy: PrivacyPolicyPage,
};
